import { render, staticRenderFns } from "./AdministracionSubTab.vue?vue&type=template&id=41615778&"
import script from "./AdministracionSubTab.vue?vue&type=script&lang=js&"
export * from "./AdministracionSubTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports